import { extend, override } from 'flarum/common/extend';
import SettingsPage from 'flarum/forum/components/SettingsPage';
import Button from 'flarum/common/components/Button';

extend(SettingsPage.prototype, 'accountItems', function(items) {
  items.remove('changePassword');

  items.replace(
    'changeEmail',
    <Button className="Button" onclick={() =>  window.open('https://my.cloud.gg/settings','_blank')}>
      Change Email (via CloudGG)
    </Button>
  );
});
